import {Avatar} from '@mantine/core';
import {BiAt} from "react-icons/bi";

export const RecordIcon = ({
                               size = 'md',
                           }: {
    size?: string
}) => {
    return (
        <Avatar size={size}>
            <BiAt/>
        </Avatar>
    );
};




